// extracted by mini-css-extract-plugin
export default {"announcements":"announcements_announcements__dWuEN","title":"announcements_title__qeKik","subtitle":"announcements_subtitle__d4ILP","note":"announcements_note__nwkZI"};